//  注册的请求模块
import Qs from "qs";
import request from "@/utils/request";

export const zhuCe = data => {
  return request({
    method: "POST",
    url: "/jyRegister.htm",
    data: Qs.stringify(data),
  });
};

//网页title
export const names = () => {
  return request({
    method: "GET",
    url: "/systemName.htm",
  });
};

//logout
export const logout = () => {
  return request({
    method: "GET",
    url: "/signout.htm",
  });
};
